import * as Model from "./model";

type Props = {
	value: Model.Context.MarketingVoucherEditContextType;
	children: React.ReactNode;
};

export const MarketingVoucherEditContextProvider = ({ value, children }: Props) => {
	return (
		<Model.Context.MarketingVoucherEditContext.Provider value={value}>
			{children}
		</Model.Context.MarketingVoucherEditContext.Provider>
	);
};
